import React, { useState } from 'react';
import api from '../services/api';
import { toast } from 'react-hot-toast';
import { showSuccessToast, showInfoToast, showErrorToast } from '../utils/toastConfig';

const LocationNewsletter = () => {
  return (
    <section id="contacto" className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Columna Izquierda: Mapa */}
          <div className="w-full">
            <iframe
              title="Mapa Frahda Studio"
              src="https://www.google.com/maps?q=Matias%20Rojas%201541,%20Antofagasta&output=embed"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Columna Derecha: Newsletter */}
          <div className="bg-primary-light rounded-none p-6 md:p-8">
            <h3 className="font-serif text-3xl mb-3">Forma parte del Frahda Club</h3>
            <p className="text-gray-800 mb-6">y entérate de ofertas exclusivas</p>
            <NewsletterForm />
          </div>
        </div>
      </div>
    </section>
  );
};

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !name) {
      showErrorToast(toast, 'Por favor completa tu nombre y email.');
      return;
    }
    setLoading(true);
    try {
      await api.post('users/subscribers/', { email, name });
      showSuccessToast(toast, '¡Gracias por suscribirte al Frahda Club!');
      setEmail('');
      setName('');
    } catch (err) {
      // Si el error es que el email ya está registrado (duplicate)
      if (err.response?.status === 400) {
        showInfoToast(toast, 'Ya estás suscrito al Frahda Club');
      } else {
        showErrorToast(toast, 'No pudimos procesar tu suscripción. Inténtalo más tarde.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3">
      <input
        type="text"
        placeholder="Tu nombre"
        className="w-full px-4 py-2 border border-gray-300 rounded-none focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
        required
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="email"
        placeholder="Tu email"
        className="w-full px-4 py-2 border border-gray-300 rounded-none focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
        required
        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
        title="Por favor ingresa un email válido (ej: nombre@ejemplo.com)"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        type="submit"
        disabled={loading}
        className="w-full px-5 py-2 bg-primary-accent text-white rounded-none hover:bg-primary-accent/90 transition-colors disabled:opacity-60"
      >
        {loading ? 'Enviando…' : 'SUBSCRIBETE'}
      </button>
    </form>
  );
};

export default LocationNewsletter;
